module.exports = __webpack_public_path__ + "media/configurations/SO-SX-5ff75d59.png";